import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type {
  ExtratoFaturamentoFiltros,
  ExtratoFaturamentoItem,
  ExtratoFaturamentoTotais,
} from './types';

const BASE = '/v1/empresa-extrato-faturamento';

/** Filtros → query params (status multi vira CSV; nulos/vazios omitidos). */
function filtroParams(
  filtros: ExtratoFaturamentoFiltros,
): Record<string, string | number | boolean | undefined | null> {
  return {
    colaboradorCodigo: filtros.colaboradorCodigo ?? undefined,
    clienteCodigo: filtros.clienteCodigo ?? undefined,
    status: filtros.status && filtros.status.length > 0 ? filtros.status.join(',') : undefined,
    faturamentoParcial: filtros.faturamentoParcial ?? undefined,
    periodoAno:
      filtros.periodoAno != null && filtros.periodoMes != null ? filtros.periodoAno : undefined,
    periodoMes:
      filtros.periodoAno != null && filtros.periodoMes != null ? filtros.periodoMes : undefined,
  };
}

/** List paginado do extrato (card [8RE0BKQ9]). */
export async function listExtratoFaturamento(
  query: DataTableQuery,
  filtros: ExtratoFaturamentoFiltros,
): Promise<ListEnvelope<ExtratoFaturamentoItem>> {
  const { data } = await api.get<{
    data: ExtratoFaturamentoItem[];
    meta: { total: number; pagina?: number; porPagina?: number };
  }>(BASE, { params: toGenexusParams(query, filtroParams(filtros)) });
  return normalizeListEnvelope(data);
}

/** Totais do conjunto filtrado — mesmos filtros do List, sem paginação. */
export async function getExtratoFaturamentoTotais(
  filtros: ExtratoFaturamentoFiltros,
  busca?: string,
): Promise<ExtratoFaturamentoTotais> {
  const params: Record<string, unknown> = { ...filtroParams(filtros) };
  if (busca) params.busca = busca;
  for (const k of Object.keys(params)) {
    if (params[k] === undefined || params[k] === null) delete params[k];
  }
  const { data } = await api.get<{ data: ExtratoFaturamentoTotais }>(`${BASE}/totals`, { params });
  return data.data;
}
